export default {
  campaigns: state => state.newsletter.campaigns,
  campaignInfos: state => state.newsletter.campaignInfos,
  totalPages: state => state.totalPages
}
